import React from "react";
import ReactDOM from "react-dom";
import { services } from "./static/services.json";
import ServicesList from './components/Services/ServicesList';

ReactDOM.render(
    <ServicesList services={services}/>,
    document.getElementById('services-list')
);
